import { handleError } from '../errorHandling';
import authRequest from '../authRequest';
import NoteTypePresenter from '../../presenters/NoteTypePresenter';

const fetchNoteType = async (noteTypeSlug) => {
  if (!noteTypeSlug) {
    throw new Error('note_type_slug is required');
  }

  try {
    const response = await authRequest(`/note_types/${noteTypeSlug}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    return new NoteTypePresenter(response.data);
  } catch (error) {
    handleError(error, 'Failed to fetch note type');
    throw error;
  }
};

export default fetchNoteType;


